import React from "react";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import theme from 'theme';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface WidgetProps {
    title?: string;
    subtitle?: string;
    icon?: React.ReactNode;
    children: React.ReactNode;
    actions?: boolean;
}

const Widget = (props:WidgetProps) => {
    return (
        <Card
          sx={{
            marginBottom: 2,
            backgroundColor: (theme) => theme.palette.background.paper,
          }}
          variant="outlined"
        >
        {props.title &&
        <CardHeader
          avatar={props.icon ?
            <Avatar
              sx={{
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark'
                    ? theme.palette.secondary.main   // giallo in dark mode
                    : theme.palette.primary.main,    // colore originale in light
              }}
              aria-label="recipe"
            >
              {props.icon}
            </Avatar>
          : false }
          title={props.title}
          titleTypographyProps={{variant:'pageTitle', marginLeft:0}}
          subheader={props.subtitle??''}
        >
        </CardHeader>}

        <CardContent>
            {props.children}
        </CardContent>

        {props.actions &&
        <CardActions disableSpacing>
          <IconButton aria-label="add to favorites">
            <FavoriteIcon />
          </IconButton>
          <IconButton aria-label="share">
            <ShareIcon />
          </IconButton>
        </CardActions>}

      </Card>
    );
}
export default Widget;